export const OAUTH_STATE_KEY = "loa_oauth_state";
export const BASE_DOMAIN = (import.meta.env.VITE_BASE_DOMAIN as string) ?? "loa.localhost";
export const TENANT_HEADER = (import.meta.env.VITE_TENANT_HEADER as string) ?? "X-Tenant";
export const ACTIVE_TENANT_COOKIE = "loa_active_tenant";
/** Marks a logout the user actually asked for (LOA-1617). */
export const LOGOUT_INTENT_KEY = "loa_logout_intent";
/** Carries that intent's nonce on the navigation to the logout route. */
export const LOGOUT_INTENT_PARAM = "i";
/** How long a recorded logout intent stays usable, in milliseconds. */
export const LOGOUT_INTENT_TTL_MS = 5 * 60 * 1000;
export const SAFE_FALLBACK_ROUTE = "/dashboard";
export const LOGIN_ROUTE = "/auth/login";
export const LOGOUT_ROUTE = "/auth/logout";
export const ERROR_ROUTE = "/auth/error";
export const SUCCESS_ROUTE = "/auth/success";
